const clg2 = "color: yellow; font-size: 14px";

let allProductIdPreventa = sectionCollectionProducts.map((prod) => prod.id);
let preventaCollectionUrl = sectionCollectionUrl;

let messageCartPreventa = sectionMessageCartPreventa;
let messageCartTemporada = sectionMessageCartTemporada;
let messageProdPagePreventa = sectionProductPageMessagePreventa;
let messageProdPageTemporada = sectionProductPageMessageTemporada;
let messageCollPagePreventa = sectionCollectionPageMessagePreventa;
let messageCollPageTemporada = sectionCollectionPageMessageTemporada;
let messageRemovedPreventaFromCart = sectionDeletedItemMessage;
let messageAtc = sectionMessageAtc;  
let datos ;
//--------------------------------------------------------------------------------------------------
//                                   PAGE RENDERING PREVENTA
//--------------------------------------------------------------------------------------------------
function pageRenderingPreventa(){
  console.log("%c 🚀 PREVENTA 🚀", clg2);
  Promise.all([getCartItems()])
    .then(([cart]) => {
 
      let allCartProductId = cart.map((el) => el.product_id);
      let isCartEmpty = cart.length === 0;
      
      datos = {
        isCartPreventa: allCartProductId.some((value) => allProductIdPreventa.includes(value)),
        isCartTemporada: allCartProductId.some((value) => !allProductIdPreventa.includes(value)),
        allProductIdPreventa : allProductIdPreventa,
      };
       
      if(isProductPage() || currentUrl.includes("/pages/amunt")){
        editProductPage()
        waitForSectionToBeLoaded(".m-product-recommendations__wrapper",disableCardAtc )
      }
      else if(isCollectionPage()){
        editCollectionPage()
      }
      else {
        disableCardAtc()
      }

      let isCartMixed = datos.isCartPreventa && datos.isCartTemporada;
      if (datos.isCartMixed){
        console.log("HAY UN PROBLEMA EN EL CODIGO")
      }
      if (isCartEmpty){
        resetThePage();
      }
   
    }); // end then
}
//--------------------------------------------------------------------
// COLLECTION PAGE  
//--------------------------------------------------------------------

function editCollectionPage(){
  console.log("%c 🕓 editCollectionPage", clg2);
  
  let isPreventaCollection = window.location.href.includes(`${preventaCollectionUrl}`);
  let isTemporadaCollection = !window.location.href.includes(`${preventaCollectionUrl}`);
  if (isPreventaCollection && datos.isCartTemporada) {
    showCollectionMessage("preventa");
  }
  if (isTemporadaCollection && datos.isCartPreventa) {
    showCollectionMessage("temporada");
  }
  disableCardAtc();
  doItWhenProductListGrows(disableCardAtc)
}
function showCollectionMessage(status) {
   let messageAlreadyExists = document.querySelector(".pango-preventa-element")
   if (!messageAlreadyExists){
      let collectionHeaderMessage;
      if (status === "temporada") {
        collectionHeaderMessage = messageCollPageTemporada;
      }
      if (status === "preventa") {
        collectionHeaderMessage = messageCollPagePreventa;
      }
  
      let collectionHeader = document.querySelector("m-collection-header");
      if (collectionHeader) {
        let newDiv = document.createElement("div");
        newDiv.classList.add("pango-preventa-element");
        newDiv.classList.add("pango-preventa-collection-banner");
        let messageDiv = document.createElement("div");
        messageDiv.innerHTML = collectionHeaderMessage;
        newDiv.appendChild(messageDiv);
        collectionHeader.appendChild(newDiv);
      }       
   }
} 
  

 
//--------------------------------------------------------------------
//  FUNCIONES QUE REUTILIZAMOS PARA TODAS LAS SECCIONES CON PRODUCT CARDS
//--------------------------------------------------------------------
// hide atc and replace with a fake btn
function disableCardAtc() {
  console.log("%c 🕓 dentro disableCardAtc ", clg2);
  let targetParent;
  if(isProductPage()){
    waitForSectionToBeLoaded(".m-product-recommendations__wrapper", compareProdId )
  }
  else if(isCollectionPage() || isSearchPage()){
    targetParent = document.getElementById("CollectionProductGrid")
    compareProdId(targetParent)
  }
  else if(isCartPage()){
    waitForSectionToBeLoaded("m-featured-collection", compareProdId )
  }
  else if(isWishlistPage()){
    targetParent = document.querySelector(".m-product-list");
    waitForSectionToBeLoaded2(".m-product-list", '.pango-custom-card', ()=>compareProdId(targetParent));
    let targetParent2 = document.querySelector(".m-wishlist-page-content__wrapper");    
    waitForSectionToBeLoaded2('.m-wishlist-page-content__wrapper', '.pango-custom-card', ()=>compareProdId(targetParent2) ) 
  }   
  //sidecart
  sidecartParent = document.getElementById("recommend-product-drawner_section");   
  waitForSectionToBeLoaded2('#recommend-product-drawner_section', '.pango-custom-card', ()=>compareProdId(sidecartParent) ) 
}
function compareProdId(targetParent){
  let allCards = targetParent.querySelectorAll(".pango-custom-card" );
 
  if (allCards.length > 0) {
    allCards.forEach((card) => {
      let cardProdData =  JSON.parse(card.querySelector('script[type="application/json"]').textContent);
      let cardProdId = cardProdData.id;
      let isProductPreventa = datos.allProductIdPreventa.some((el) => el === cardProdId);
      let isProductTemporada = !datos.allProductIdPreventa.some((el) => el === cardProdId);
      if(datos.isCartPreventa && isProductTemporada || datos.isCartTemporada && isProductPreventa ){
        hideAndReplaceATC(card);
      }
    });
  }
}
function hideAndReplaceATC(card) {
  console.log("%c 🕓 dentro hideAndReplaceATC ", clg2);
  let messageToShowATC = "";
  if (datos.isCartTemporada) {
    messageToShowATC = messageCartTemporada;
  } else if (datos.isCartPreventa) {
    messageToShowATC = messageCartPreventa;
  }
  let buttonToHide = card.querySelector(".m-add-to-cart");
  if (buttonToHide) {
    buttonToHide.style.display = "none";
    let buttonToShow = card.querySelector(".buttonToShow");
    if (!buttonToShow) {
      let newButtonToShow = document.createElement("div");
      newButtonToShow.textContent = messageAtc;
      newButtonToShow.className =
        "buttonToShow pango-preventa-element pango-preventa-fake-atc   w-full flex-grow   m-button m-button--primary";
      buttonToHide.insertAdjacentElement("afterend", newButtonToShow);
    }
    // on click open popup
    let allBtnToShow = document.querySelectorAll(".buttonToShow");
    if (allBtnToShow.length > 0) {
      allBtnToShow.forEach((btn) => {
        btn.addEventListener("click", () => {
          Swal.fire({
            title: "AVISO",
            html: `<p>${messageToShowATC}</p> ` + "<br><hr><br>",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
      });
    }
  }
}
//--------------------------------------------------------------------
// PRODUCT PAGE - main product
//--------------------------------------------------------------------
function editProductPage(){
  console.log("%c 🕓 editProductPage", clg2);
  const parentElement = document.querySelector(".main-product__block-buy_buttons");
  const productIdElement = parentElement.querySelector(".m-product-form--main").getAttribute("data-product-id");
  
  if (productIdElement) {
    const productId = Number(productIdElement);
    console.log("%c 🕓 productId", clg2, productId);
    let isProductPreventa = datos.allProductIdPreventa.some((el) => el === productId);
    let isProductTemporada = !datos.allProductIdPreventa.some((el) => el === productId);

    if (isProductPreventa && datos.isCartTemporada) {
      showProductPageMessage("preventa");
      hideStickyBar();
    }
    if (isProductTemporada && datos.isCartPreventa) {
      showProductPageMessage("temporada");
      hideStickyBar();
    }
  }  
}
function showProductPageMessage(status) {
  let messageAlreadyExists = document.querySelector(".pango-preventa-element")
  if (!messageAlreadyExists){
      let prodPageMessage;
      if (status === "temporada") {
        prodPageMessage = messageProdPageTemporada;
      }
      if (status === "preventa") {
        prodPageMessage = messageProdPagePreventa;
      }

      let elementToHide = document.querySelector( ".main-product__block-buy_buttons" );
      elementToHide.style.display = "none";
      if (elementToHide) {
        let newDiv = document.createElement("div");
        newDiv.classList.add("pango-preventa-element");
        newDiv.classList.add("pango-preventa-product-page-banner");
        let messageDiv = document.createElement("div");
        messageDiv.innerHTML = prodPageMessage;
        newDiv.appendChild(messageDiv);
        elementToHide.parentNode.insertBefore(newDiv, elementToHide);
      }
  }
}
function hideStickyBar() {
  let stickyBarDOM = document.querySelector("div.m-sticky-addtocart");
  if (stickyBarDOM) {
    stickyBarDOM.style.display = "none";  
  };
};


//--------------------------------------------------------------------
// VARIOUS FUNCTIONS
//--------------------------------------------------------------------
function resetThePage() {
  console.log("%c 🕓dentro resetThePage", clg2);
  
  if (isSearchPage || isCollectionPage || isProductPage || isWishlistPage ) {
    let pangoCollectionElements = document.querySelectorAll(".pango-preventa-element");
    if (pangoCollectionElements.length > 0) {
      pangoCollectionElements.forEach((el) => el.remove());
    }
    
    let originalATC = document.querySelectorAll(".m-add-to-cart");
    if (originalATC.length > 0) {
      originalATC.forEach((button) => {
        button.style.display = "block";
      });
    }

    let originalATCProdPage = document.querySelector(
      ".main-product__block-buy_buttons"
    );
    if (originalATCProdPage) {
      originalATCProdPage.style.display = "block";
    }

    let originalStickyBar = document.querySelector("div.m-sticky-addtocart");
    if (originalStickyBar) {
      originalStickyBar.style.display = "block";  
    };
  }
}
//--------------------------------------------------------------------
// START
//--------------------------------------------------------------------

//on load
document.addEventListener("DOMContentLoaded", function() {
  onSideCartOpen(disableCardAtc)
});
pageRenderingPreventa()
// on cart update
window.addEventListener('pangoCartUpdateEvent', function(event) {
  pageRenderingPreventa()
});









//-------------------------------------------------------------------------------------------------- 
//                                         CART VALIDATION PREVENTA
//--------------------------------------------------------------------------------------------------
function cartValidationPreventa(){
  Promise.all([getCartItems()])
    .then(([cart]) => {
      let isCartEmpty = cart.length === 0;
      if (isCartEmpty) {
        console.log("%c 🕓 isCartEmpty", clg2, isCartEmpty);
      } else {
        notEmptyCart(cart)
      }      
    }); 
}
//--------------------------------------------------------------------
function getCartItems() {
  return new Promise((resolve, reject) => {
    jQuery.getJSON("/cart.js", function (cart) {
      let cartItems = cart.items;
      resolve(cartItems);
    });
  });
}
//--------------------------------------------------------------------
function notEmptyCart(cart){
  let allCartProductId = cart.map((el) => el.product_id);
  let isCartPreventa = allCartProductId.some((value) => allProductIdPreventa.includes(value) );
  let isCartTemporada = allCartProductId.some((value) => !allProductIdPreventa.includes(value) );
  let isCartMixed = isCartPreventa && isCartTemporada;

  // console.log("%c 🕓 allCartProductId ", clg2, allCartProductId);
  // console.log("%c 🕓 isCartMixed ", clg2, isCartMixed);
  // console.log("%c 🕓 isCartPreventa ", clg2, isCartPreventa);
  // console.log("%c 🕓 isCartTemporada ", clg2, isCartTemporada);
  
  if (isCartMixed) {
    removeTemporadaFromCart(cart);
  } 
}
//--------------------------------------------------------------------
function removeTemporadaFromCart(cart) {
  console.log("%c 🕓 removeTemporadaFromCart()", clg2);
  // get all the variants preventa in the cart
 
  console.log("cart",cart)
  let cartVariantsTemporadaToDelete = cart
    .filter((el) => !allProductIdPreventa.includes(el.product_id))
    .map((el) => el.id);

  function compareIdsWithObjects(idsArray, objectsArray) {
    const result = {};
    for (const id of idsArray) {
      for (const obj of objectsArray) {
        if (obj.id === Number(id)) {
          result[id] = 0;
          break;
        }
      }
    }
    return result;
  }
  const variantsToremove = compareIdsWithObjects(cartVariantsTemporadaToDelete, cart);

  // remove the variants preventa from the cart
  if (Object.keys(variantsToremove).length !== 0) {
      jQuery.post(window.Shopify.routes.root + "cart/update.js", {
        updates: variantsToremove,
      });
  
      Swal.fire({
        title: "AVISO",
        html:
          `<div>${messageRemovedPreventaFromCart}</div> ` + "<br><hr><br>",
        icon: "error",
        confirmButtonText: "OK",
      })
      .then(() => location.reload());
  } // end if
} // end removeTemporadaFromCart

//--------------------------------------------------------------------
// START CART VALIDATION
//--------------------------------------------------------------------
// ON PAGE LOAD cualquier pagina
cartValidationPreventa()

// ON CART UPDATE
window.addEventListener('pangoCartUpdateEvent', function(event) {
  cartValidationPreventa()
});
//--------------------------------------------------------------------
 
 